
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
data () {
return {
currentItem: [],
enumType: this.$route.params.enumtype,
expendResult: [],
expendClass: 'fa fa-angle-double-down',
dropdownTitle: '展开目录结构'
}
},
methods: {
async loadData () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
console.log(this.$route.params)
console.log(this.$route.params.item.ID)
console.log(this.currentItem)
let queryPromise = await this.$http.get('/API/NodeSearch/Detail', { params: { id: this.$route.params.item.ID} })
this.currentItem = queryPromise.data.Main
console.log("有效数据：")
console.log(this.currentItem)
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
async activated () {
await this.loadData()
}
}



// WEBPACK FOOTER //
// ./src/components/NodeSearchOneDetail.vue